import React, { useEffect, useState } from "react";
import MirumGrid from "components/MirumGrid";
import useAPI from "hooks/useAPI";
import moment from "moment";
import Price from "components/Creation/components/Confirm/components/BookingSummary/components/Cost/components/Price";
const Bookings = () => {
  const { API } = useAPI({});
  const [bookings, setBookings] = useState([]);
  const [statusToShow, setStatusToShow] = useState("confirmed");
  useEffect(() => {
    getAndSetBookings();
  }, [statusToShow]);
  const getAndSetBookings = async () => {
    const data = await API.get(
      `/admin/bookings${statusToShow ? "?status=" + statusToShow : ""}`
    );
    setBookings(data?.bookings);
  };

  const priceRenderer = (params) => {
    return params.value ? <Price value={params.value} /> : null;
  };
  return (
    <div className="container mx-auto py-8">
      <h1>Bookings</h1>
      <ul className="flex gap-2 lowercase my-2">
        <li>showing:</li>
        <li
          onClick={() => {
            setStatusToShow("confirmed");
          }}
          className={`cursor-pointer ${
            statusToShow === "confirmed" ? "underline" : ""
          }`}
        >
          <a>Confirmed</a>
        </li>
        <li
          onClick={() => {
            setStatusToShow(null);
          }}
          className={`cursor-pointer  ${!statusToShow ? "underline" : ""}`}
        >
          <a>All</a>
        </li>
      </ul>
      <MirumGrid
        rowData={bookings}
        addColumnDefs={[
          {
            field: "user.email",
          },
          {
            headerName: "View Details",
            cellRenderer: (params) => {
              console.log("params", params);
              return params?.data?.status === "confirmed" ? (
                <a
                  href={`/admin/bookings/${params.data._id}`}
                  className="underline"
                >
                  View Selection
                </a>
              ) : null;
            },
          },
          {
            field: "stripe.paymentIntent.status",
          },

          {
            field: "cost.bookingFee",
            cellRenderer: priceRenderer,
          },
          {
            field: "cost.additional3Surprises",
            cellRenderer: priceRenderer,
          },
          {
            field: "cost.discount",
            cellRender: priceRenderer,
          },
          {
            field: "cost.vat",
            cellRenderer: priceRenderer,
          },
          {
            field: "cost.total",
            cellRenderer: priceRenderer,
          },
          {
            field: "selection.when.date",
            cellRenderer: (params) => {
              return moment(params.value).format("DD/MM/YYYY");
            },
          },
          {
            field: "selection.when.startTime",
          },
          {
            field: "createdAt",
            cellRenderer: (params) => {
              return moment(params.value).format("DD/MM/YYYY HH:MM");
            },
          },
          {
            headerName: "Original Booking (add. 3 surprises)",
            field: "sourceBooking",
          },
          {
            field: "selection.discountCode",
          },
          {
            field: "user.dob",
          },
          {
            field: "user.mobileNumber",
          },
          {
            field: "user.name",
          },
          {
            field: "user.marketingAccepted",
            cellRenderer: (params) => {
              return params.value ? "Yes" : "No";
            },
          },
        ]}
        showFields={["status", "createdAt", "_id"]}
        height={600}
      />
    </div>
  );
};
export default Bookings;
